function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 8px 12px;\n  font-size: 0.875rem;\n  border: 1px solid;\n  border-radius: 4px;\n  min-width: auto;\n  cursor: pointer;\n  box-sizing: border-box;\n  font-weight: ", ";\n  display: inline-flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  text-decoration: none;\n  line-height: 1.5;\n  text-transform: capitalize;\n  svg {\n    margin: 0 5px;\n  }\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n  &:focus {\n    outline: 3px solid ", ";\n    outline-offset: 2px;\n  }\n  &:active {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n  &:disabled {\n    cursor: not-allowed;\n    background: none;\n    color: ", ";\n    border: none;\n  }\n  &.contained,\n  &.outlined:hover {\n    color: ", ";\n    border: none;\n    background-color: ", ";\n    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n    .icon {\n      fill: ", ";\n    }\n    &:disabled {\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n    }\n    ", ";\n  }\n  &.contained:hover,\n  &.outlined {\n    background-color: ", ";\n    color: ", ";\n    border: 2px solid ", ";\n    &:disabled {\n      border: 2px solid ", ";\n    }\n    ", ";\n  }\n  &.text {\n    background: none;\n    color: ", ";\n    border: 1px solid transparent;\n    text-transform: none;\n    &:hover {\n      background-color: ", ";\n    }\n    &:disabled {\n      color: ", ";\n    }\n    ", ";\n  }\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { defaultTheme } from '../../../utils';
var BUTTON_MODIFIERS = {
  small: function small(_ref) {
    var theme = _ref.theme;
    return "\n    font-size: " + theme.typeScale.helperText + ";\n    padding: 8px;\n  ";
  },
  large: function large(_ref2) {
    var theme = _ref2.theme;
    return "\n    font-size: " + theme.typeScale.regular + ";\n    padding: 8px 24px;\n  ";
  },
  warning: function warning(_ref3) {
    var theme = _ref3.theme;
    return "\n    background: none;\n    color: " + theme.status.warningColor + ";\n    &:hover, &:focus {\n      background-color: " + theme.status.warningColorHover + ";\n      outline: 3px solid " + theme.status.warningColorHover + ";\n      outline-offset: 2px;\n      border: 2px solid transparent;\n    }\n\n    &:active {\n      background-color: " + theme.status.warningColorActive + ";\n    }\n  ";
  },
  containedButtonWarning: function containedButtonWarning(_ref4) {
    var theme = _ref4.theme;
    return "\n    background-color: " + theme.status.warningColor + ";\n    color: " + theme.textColorInverted + ";\n    &:hover, &:focus {\n      background-color: " + theme.status.warningColorHover + ";\n      border: 2px solid transparent;\n    }\n  ";
  },
  outlinedButtonWarning: function outlinedButtonWarning(_ref5) {
    var theme = _ref5.theme;
    return "\n    border: 2px solid " + theme.status.warningColor + ";\n    color: " + theme.status.warningColor + ";\n    &:hover, &:focus {\n      background-color: " + theme.status.warningColorHover + ";\n      color: " + theme.textColorInverted + ";\n      border: 2px solid transparent;\n    }\n  ";
  },
  textButtonWarning: function textButtonWarning(_ref6) {
    var theme = _ref6.theme;
    return "\n    color: " + theme.status.warningColor + ";\n  ";
  },
  error: function error(_ref7) {
    var theme = _ref7.theme;
    return "\n    background: none;\n    color: " + theme.status.errorColor + ";\n    &:hover, &:focus {\n      background-color: " + theme.status.errorColorHover + ";\n      border: 2px solid transparent;\n    }\n    &:active {\n      background-color: " + theme.status.errorColorActive + ";\n    }\n  ";
  },
  containedButtonError: function containedButtonError(_ref8) {
    var theme = _ref8.theme;
    return "\n    background-color: " + theme.status.errorColor + ";\n    color: " + theme.textColorInverted + ";\n    &:hover, &:focus {\n      background-color: " + theme.status.errorColorHover + ";\n      border: 2px solid transparent;\n    }\n  ";
  },
  outlinedButtonError: function outlinedButtonError(_ref9) {
    var theme = _ref9.theme;
    return "\n    border: 2px solid " + theme.status.errorColor + ";\n    color: " + theme.status.errorColor + ";\n    &:hover, &:focus {\n      background-color: " + theme.status.errorColorHover + ";\n      color: " + theme.textColorInverted + ";\n      border: 2px solid transparent;\n    }\n  ";
  },
  textButtonError: function textButtonError(_ref10) {
    var theme = _ref10.theme;
    return "\n    color: " + theme.status.errorColor + ";\n  ";
  },
  success: function success(_ref11) {
    var theme = _ref11.theme;
    return "\n    background: none;\n    color: " + theme.status.successColor + ";\n    &:hover, &:focus {\n      background-color: " + theme.status.successColorHover + ";\n      outline: 3px solid " + theme.status.successColorHover + ";\n      outline-offset: 2px;\n      border: 2px solid transparent;\n    }\n    &:active {\n      background-color: " + theme.status.successColorActive + ";\n    }\n  ";
  },
  containedButtonSuccess: function containedButtonSuccess(_ref12) {
    var theme = _ref12.theme;
    return "\n    background-color: " + theme.status.successColor + ";\n    color: " + theme.textColorInverted + ";\n    border: none;\n    &:hover, &:focus {\n      background-color: " + theme.status.successColorHover + ";\n      border: 2px solid transparent;\n    }\n    &:active {\n      background-color: " + theme.status.successColorActive + ";\n    }\n  ";
  },
  outlinedButtonSuccess: function outlinedButtonSuccess(_ref13) {
    var theme = _ref13.theme;
    return "\n    border: 2px solid " + theme.status.successColor + ";\n    color: " + theme.status.successColor + ";\n    &:hover, &:focus {\n      background-color: " + theme.status.successColorHover + ";\n      color: " + theme.textColorInverted + ";\n      border: 2px solid transparent;\n    }\n    &:active {\n      background-color: " + theme.status.successColorActive + ";\n    }\n  ";
  },
  textButtonSuccess: function textButtonSuccess(_ref14) {
    var theme = _ref14.theme;
    return "\n    color: " + theme.status.successColor + ";\n  ";
  },
  textCancelButton: function textCancelButton(_ref15) {
    var theme = _ref15.theme;
    return "\n    color: " + theme.status.cancel + ";\n  ";
  },
  textSaveButton: function textSaveButton(_ref16) {
    var theme = _ref16.theme;
    return "\n    color: " + theme.status.save + ";\n  ";
  }
};
var StyledButton = styled.button(_templateObject(), function (_ref17) {
  var theme = _ref17.theme;
  return theme.primaryFontWeight;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.primaryHoverColor;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.textColorOnPrimary;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.primaryHoverColor;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.primaryActiveColor;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.primaryActiveColor;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.textColorOnPrimary;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.disabled;
}, function (_ref25) {
  var theme = _ref25.theme,
      _ref25$color = _ref25.color,
      color = _ref25$color === void 0 ? 'primary' : _ref25$color;
  return theme.colors["" + color].textColor;
}, function (_ref26) {
  var theme = _ref26.theme,
      _ref26$color = _ref26.color,
      color = _ref26$color === void 0 ? 'primary' : _ref26$color;
  return theme.colors["" + color]["default"];
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.neutralColor;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.disabled;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.textOnDisabled;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.disabled;
}, applyStyleModifiers(BUTTON_MODIFIERS), function (_ref31) {
  var theme = _ref31.theme,
      _ref31$color = _ref31.color,
      color = _ref31$color === void 0 ? 'primary' : _ref31$color;
  return theme.colors["" + color].hover;
}, function (_ref32) {
  var theme = _ref32.theme,
      _ref32$color = _ref32.color,
      color = _ref32$color === void 0 ? 'primary' : _ref32$color;
  return theme.colors["" + color]["default"];
}, function (_ref33) {
  var theme = _ref33.theme,
      _ref33$color = _ref33.color,
      color = _ref33$color === void 0 ? 'primary' : _ref33$color;
  return theme.colors["" + color]["default"];
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.disabled;
}, applyStyleModifiers(BUTTON_MODIFIERS), function (_ref35) {
  var theme = _ref35.theme,
      _ref35$color = _ref35.color,
      color = _ref35$color === void 0 ? 'primary' : _ref35$color;
  return theme.colors["" + color]["default"];
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.textHoverColor;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.textOnDisabled;
}, applyStyleModifiers(BUTTON_MODIFIERS), applyStyleModifiers(BUTTON_MODIFIERS));

var CustomButton = function CustomButton(_ref38) {
  var children = _ref38.children,
      variant = _ref38.variant,
      className = _ref38.className,
      rest = _objectWithoutPropertiesLoose(_ref38, ["children", "variant", "className"]);

  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    className: variant + " " + className
  }, rest), children);
};

CustomButton.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string
} : {};
CustomButton.defaultProps = {
  theme: defaultTheme,
  variant: '',
  className: ''
};
export default CustomButton;